<lib-data-table [data]="organisations"
  [columns]="columns"
  [showFilter]="false"
  [showPaginator]="false" />